import { Injectable } from "@angular/core";
import { UrlTree } from "@angular/router";
import { LogoutGuard } from "@spartacus/storefront";

@Injectable({
  providedIn: 'root',
})
export class CustomLogoutGuard extends LogoutGuard {
  protected override getRedirectUrl(): UrlTree {
    const cxRoute = 'login';
    return this.router.parseUrl(this.semanticPathService.get(cxRoute) ?? '');
  }
}